import { USER_ROLES } from 'src/app/config/user-roles';
import { NavItem } from './nav-item/nav-item';
import { PERMISSIONS } from 'src/app/config/permissions.constant';
import { RENTALS_PERMISSIONS } from 'src/app/config/rentals.permissions';
import { environment } from 'src/environments/environment';

export const navItems: NavItem[] = [
  // Home
  {
    navCap: 'Home',
    perms: [PERMISSIONS.DASHBOARD]
  },
  {
    displayName: 'Dashboard',
    iconName: 'layout-dashboard',
    route: '/dashboard',
    perms: [PERMISSIONS.DASHBOARD]
  },
  // Hidden from the menu in staging and production (environment flag); /school/dashboard-v2 still works by its URL
  ...(environment.showDashboardV2
    ? [{
      displayName: 'Dashboard V2',
      iconName: 'layout-dashboard',
      route: '/school/dashboard-v2',
      perms: [PERMISSIONS.DASHBOARD_V2]
    }]
    : []),

  // Student Management
  {
    navCap: 'Student Management',
    perms: [PERMISSIONS.SCHOOL_STUDENTS]
  },
  {
    displayName: 'Students',
    iconName: 'school',
    route: '/school/students',
    subset: true,
    perms: [PERMISSIONS.SCHOOL_STUDENTS]
  },

  // Bookings
  {
    navCap: 'Bookings',
    perms: [PERMISSIONS.SCHOOL_BOOKINGS]
  },
  {
    displayName: 'List',
    iconName: 'list-details',
    route: '/school/booking',
    perms: [PERMISSIONS.SCHOOL_BOOKINGS]
  },
  {
    displayName: 'Arrivals',
    iconName: 'plane-arrival',
    route: '/school/arrivals',
    perms: [PERMISSIONS.SCHOOL_BOOKINGS]
  },

  // Lessons
  {
    navCap: 'Lessons',
    perms: [PERMISSIONS.SCHOOL_STUDENT_EXCHANGE, PERMISSIONS.SCHOOL_LESSONS]
  },
  {
    displayName: 'Today',
    iconName: 'calendar-event',
    route: '/school/today-lessons',
    perms: [PERMISSIONS.SCHOOL_LESSONS]
  },
  {
    displayName: 'Planning',
    iconName: 'calendar-stats',
    route: '/school/planning',
    perms: [PERMISSIONS.SCHOOL_STUDENT_EXCHANGE]
  },

  // Boxes
  {
    navCap: 'Boxes',
    perms: [PERMISSIONS.SCHOOL_BOXES]
  },
  {
    displayName: 'Workboard',
    iconName: 'layout-kanban',
    route: '/boxes/list',
    perms: [PERMISSIONS.SCHOOL_BOXES]
  },
  {
    displayName: 'Boxes',
    iconName: 'box',
    route: '/boxes/crud',
    perms: [PERMISSIONS.SCHOOL_BOXES]
  },
  {
    displayName: 'Zones',
    iconName: 'map-pin',
    route: '/boxes/zones',
    perms: [PERMISSIONS.SCHOOL_BOXES]
  },
  {
    displayName: 'Box Sizes',
    iconName: 'resize',
    route: '/boxes/box-sizes',
    perms: [PERMISSIONS.SCHOOL_BOXES]
  },

  // Rentals
  {
    navCap: 'Rentals',
    perms: [...RENTALS_PERMISSIONS.VIEW_MODULE]
  },
  {
    displayName: 'Today',
    iconName: 'wave-sine',
    route: '/rentals/today',
    perms: [...RENTALS_PERMISSIONS.VIEW_MODULE]
  },
  {
    displayName: 'Inventory',
    iconName: 'package',
    route: '/rentals/inventory',
    perms: [...RENTALS_PERMISSIONS.VIEW_MODULE]
  },
  {
    displayName: 'Products',
    iconName: 'tag',
    route: '/rentals/products',
    perms: [...RENTALS_PERMISSIONS.VIEW_MODULE]
  },
  {
    displayName: 'Equipment Types',
    iconName: 'adjustments',
    route: '/rentals/equipment-types',
    perms: [...RENTALS_PERMISSIONS.VIEW_MODULE]
  },

  // Finance
  {
    navCap: 'Finance',
    perms: [PERMISSIONS.SCHOOL_FINANCE]
  },
  {
    displayName: 'Money',
    iconName: 'coins',
    route: '/school/finance/money',
    perms: [PERMISSIONS.SCHOOL_FINANCE]
  },
  {
    displayName: 'Transactions',
    iconName: 'arrows-left-right',
    route: '/school/finance/transactions',
    perms: [PERMISSIONS.SCHOOL_FINANCE]
  },
  {
    displayName: 'Invoices',
    iconName: 'file-invoice',
    route: '/school/finance/invoices',
    perms: [PERMISSIONS.SCHOOL_FINANCE]
  },

  // Cash: its own group, because front desk uses it and does not see Finance.
  {
    navCap: 'Cash',
    perms: [PERMISSIONS.SCHOOL_CASH]
  },
  {
    displayName: 'Cash drawer',
    iconName: 'cash',
    route: '/school/cash',
    perms: [PERMISSIONS.SCHOOL_CASH]
  },

  // Instructor
  {
    navCap: 'Instructor',
    perms: [PERMISSIONS.INSTRUCTOR, PERMISSIONS.INSTRUCTOR_LESSONS]
  },
  {
    displayName: 'Dashboard',
    iconName: 'layout-dashboard',
    route: '/instructor/dashboard',
    perms: [PERMISSIONS.INSTRUCTOR]
  },
  {
    displayName: 'Timeline',
    iconName: 'timeline',
    route: '/instructor/timeline',
    perms: [PERMISSIONS.INSTRUCTOR]
  },
  {
    displayName: 'My Lessons',
    iconName: 'calendar',
    route: '/instructor/instructor-lessons',
    perms: [PERMISSIONS.INSTRUCTOR, PERMISSIONS.INSTRUCTOR_LESSONS]
  },
  {
    displayName: 'Schools',
    iconName: 'building-community',
    route: '/instructor/instructor-schools',
    perms: [PERMISSIONS.INSTRUCTOR, PERMISSIONS.INSTRUCTOR_LESSONS]
  },

  // Settings & Utilities
  {
    navCap: 'Settings & Utilities',
    perms: [
      PERMISSIONS.SETTINGS,
      PERMISSIONS.SCHOOL_LEVELS,
      PERMISSIONS.SCHOOL_MODALITIES,
      PERMISSIONS.SCHOOL_PRODUCTS,
      PERMISSIONS.ACTIVITIES,
      PERMISSIONS.SCHOOL_MEMBERS
    ]
  },
  {
    displayName: 'Team',
    iconName: 'users',
    route: '/school/team',
    subset: true,
    perms: [PERMISSIONS.SCHOOL_MEMBERS]
  },
  {
    displayName: 'School Services',
    iconName: 'settings',
    route: '/settings',
    subset: true,
    perms: [
      PERMISSIONS.SETTINGS,
      PERMISSIONS.SCHOOL_LEVELS,
      PERMISSIONS.SCHOOL_MODALITIES,
      PERMISSIONS.SCHOOL_PRODUCTS,
      PERMISSIONS.ACTIVITIES
    ]
  }
];